// extracted by mini-css-extract-plugin
export default {"loading":"Login_loading__2V+MY","loadingOverlay":"Login_loadingOverlay__3vEUZ","loginComponent":"Login_loginComponent__hhytC","wrongPin":"Login_wrongPin__G3mX2"};